import { Image as ImageIcon } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'case_image',
    title: 'Image evidence',
    icon: ImageIcon,
    // The fill slot, where the video surface sits: a case shows one thing at a
    // time in it, and a picture wants the same room a camera does.
    width: { min: 384, default: 672, max: Infinity, fill: true },
    modes: [PanelMode.View],
    themes: PanelTheme.Any,
    isHeaderless: true,
    order: 100,
    hasNavButton: false,
});
